// extracted by mini-css-extract-plugin
export default {"container":"edit-menu_container__rQdl3","menu":"edit-menu_menu__wPCe6"};